module.exports = __webpack_public_path__ + "img/default-image.e5ec57b8.jpg";